import { SideNavLayoutState, useSideNavLayoutContext } from "@homebound/beam";
import { useEffect } from "react";

/**
 * Hides the project SideNav while mounted, then restores the previous state.
 *
 * For pages that shouldn't show SideNav but still sit under `ProjectSideNavLayout`
 * (same path as a sibling that does). Prefer routing the page outside that layout
 * when the whole URL can drop SideNav.
 */
export function useHiddenProjectSideNav() {
  const { setNavState } = useSideNavLayoutContext();
  useEffect(() => {
    let previous: SideNavLayoutState = "expanded";
    setNavState((prev) => {
      previous = prev;
      return "hidden";
    });
    return () => setNavState(previous);
  }, [setNavState]);
}
